// <s-countdown data-end="YYYY-MM-DDTHH:MM" data-timezone="Europe/Amsterdam">
// Ticks every second; hides itself once the end moment has passed.

function zonedToEpoch(local, timeZone) {
  const [datePart, timePart = '23:59'] = local.split('T');
  const [y, m, d] = datePart.split('-').map(Number);
  const [hh, mm] = timePart.split(':').map(Number);
  if (!y || !m || !d) return NaN;
  const guess = Date.UTC(y, m - 1, d, hh || 0, mm || 0, 59);
  try {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone,
      hourCycle: 'h23',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
    }).formatToParts(new Date(guess));
    const get = (type) => Number(parts.find((p) => p.type === type)?.value);
    const asUtc = Date.UTC(get('year'), get('month') - 1, get('day'), get('hour'), get('minute'), get('second'));
    return guess - (asUtc - guess);
  } catch {
    return guess;
  }
}

class SCountdown extends HTMLElement {
  #timer;

  connectedCallback() {
    this.end = zonedToEpoch(this.dataset.end || '', this.dataset.timezone || 'Europe/Amsterdam');
    this.units = {
      days: this.querySelector('[data-unit="days"]'),
      hours: this.querySelector('[data-unit="hours"]'),
      minutes: this.querySelector('[data-unit="minutes"]'),
      seconds: this.querySelector('[data-unit="seconds"]'),
    };
    this.#tick();
    this.#timer = setInterval(() => this.#tick(), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#timer);
  }

  // Seconds left in the current repeating cycle (e.g. 12 h: resets at 00:00 and 12:00 shop time).
  #cycleLeft(hours) {
    try {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: this.dataset.timezone || 'Europe/Amsterdam',
        hourCycle: 'h23', hour: '2-digit', minute: '2-digit', second: '2-digit',
      }).formatToParts(new Date());
      const get = (type) => Number(parts.find((p) => p.type === type)?.value) || 0;
      const into = (get('hour') % hours) * 3600 + get('minute') * 60 + get('second');
      return (hours * 3600 - into) * 1000;
    } catch {
      return NaN;
    }
  }

  #tick() {
    let left = this.end - Date.now();
    const cycle = Number(this.dataset.cycleHours);
    if (cycle > 0 && Number.isFinite(left) && left > 0) {
      left = Math.min(left, this.#cycleLeft(cycle));
    }
    if (!Number.isFinite(left) || left <= 0) {
      this.hidden = true;
      clearInterval(this.#timer);
      return;
    }
    const s = Math.floor(left / 1000);
    const values = {
      days: Math.floor(s / 86400),
      hours: Math.floor((s % 86400) / 3600),
      minutes: Math.floor((s % 3600) / 60),
      seconds: s % 60,
    };
    for (const [unit, el] of Object.entries(this.units)) {
      if (el) el.textContent = String(values[unit]).padStart(2, '0');
    }
  }
}

if (!customElements.get('s-countdown')) {
  customElements.define('s-countdown', SCountdown);
}
